import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'service-unavailable-dialog',
    templateUrl: './serviceUnavailableDialog.component.html',
    styleUrls: ['./serviceUnavailableDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ServiceUnavailableDialogComponent {
    data: any;

    constructor(
        public matDialogRef: MatDialogRef<ServiceUnavailableDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
    ) {
        this.data = _data.data;
    }

}
